import { ThemeProvider, createTheme } from "@mui/material/styles";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { RouterProvider } from "react-router-dom";
import router from "src/routes/router";
import SnackBarAlert from "./components/snackbar/snackbar";
import AuthProvider from "./utils/authContext";
import ErrorProvider from "./utils/errorContext";
import ToastProvider from "./utils/toastContext";

export const theme = createTheme({
  palette: {
    primary: {
      light: "#E8EBF5",
      main: "#CDD4EA",
      dark: "#4472C4",
    },
  },
});

const App = () => {
  return (
    <div>
      <GoogleOAuthProvider clientId="116298089280-l3k46rrpvgl9b38f04lj9jemdoqsktqt.apps.googleusercontent.com">
        <ThemeProvider theme={theme}>
          <ToastProvider>
            <ErrorProvider>
              <AuthProvider>
                <RouterProvider router={router} />
                <SnackBarAlert />
              </AuthProvider>
            </ErrorProvider>
          </ToastProvider>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </div>
  );
};

export default App;
